/*
 * The one place newsletter URLs are built (design §7.8.2). The newsletter is always on since 2026-09-18 (the
 * `seavien.newsletter.enabled` flag and its meta were deleted), so a builder returns `null` only when the
 * identifier it needs is missing, and every caller renders its link only for a non-null URL.
 */

/** `/newsletter/{slug}`, the publication page. */
export function newsletterPageUrl(slug?: string | null): string | null {
    if (!slug) {
        return null;
    }
    return `/newsletter/${slug}`;
}

/** `/newsletter/dashboard`, the author's list of their own newsletters. */
export function newsletterDashboardUrl(): string {
    return "/newsletter/dashboard";
}

/**
 * The author's CSV export, `GET /ajax/newsletter/{newsletterPublicId}/subscribers/export` (read off
 * `AjaxNewsletterRestController`, rule 6). Offered as a plain same-origin link rather than a blob download:
 * the session cookie travels with it and the server's `Content-Disposition: attachment` names the file.
 */
export function newsletterSubscribersExportUrl(newsletterPublicId?: string | null): string | null {
    if (!newsletterPublicId) {
        return null;
    }
    return `/ajax/newsletter/${encodeURIComponent(newsletterPublicId)}/subscribers/export`;
}

/**
 * `/newsletter/{slug}/compose`, and with an issue `?issue={issuePublicId}` (growth work order A4/D7): the composer
 * opens that draft, which `NewsletterController` hands the island as `data-issue-public-id` (owner only).
 */
export function newsletterComposeUrl(slug?: string | null, issuePublicId?: string | null): string | null {
    if (!slug) {
        return null;
    }
    const base = `/newsletter/${slug}/compose`;
    return issuePublicId ? `${base}?issue=${encodeURIComponent(issuePublicId)}` : base;
}
